module.exports = __webpack_public_path__ + "img/HOT PRODUCT.d3db3033.png";